import React from 'react';
import { Spinner } from 'selfly-ui-react';

import './loading.scss';

export default function NewLoader(props) {
    const text = typeof props.text === "string" ? props.text : "Loading ...";
    const subText = typeof props.subText === "string" ? props.subText : false;

    const dimensions = props.dimensions || { height: "auto", width: "auto"};

    return (
        <div className={`loading new-loader ${props.className}`} height={dimensions.height} width={dimensions.width}>
            <div className="spinner">
                <Spinner size="lg" />
            </div>
            <div className="text">
                <h5>{text}</h5>
                {subText && <p>{subText}</p>}
                </div>
        </div>
    );
}
